<script>
import { routeStartsWith } from '@/helpers/routes'
import { mapGetters } from 'vuex'
import bus from '@/utils/eventBus'

export default {
  name: 'sidebar',
  data () {
    return {
      menu: 'dashboard'
    }
  },
  methods: {
    hiddenMenu () {
      bus.$emit('hidden-mobile-menu', {status: false})
    }
  },
  computed: {
    ...mapGetters(['userIsProfessional', 'userIsCompany']),
    activeCompanyMe: function () {
      if (routeStartsWith(this.$route, 'professional.company.companies')) {
        this.menu = 'company-me'
        return {
          active: this.isActive
        }
      }
    },
    activeCompanyDocumente: function () {
      if (routeStartsWith(this.$route, 'professional.company.documents')) {
        this.menu = 'company-documents'
        return {
          active: this.isActive
        }
      }
    }
  }
}
</script>

<template lang="pug">
  ul
    li(v-if="userIsCompany", :class="{'active': menu === 'dashboard'}",  style="cursor: pointer",  @click.prevent="menu = 'dashboard'")
      router-link(:to="{ name: 'professional.dashboard.company.index'}", @click.native="hiddenMenu")
        span 
        | Dashboard

    li(v-if="!userIsCompany", :class="{'active': menu === 'dashboard'}",  style="cursor: pointer",  @click.prevent="menu = 'dashboard'")
      router-link(:to="{ name: 'professional.dashboard.professional.index'}", @click.native="hiddenMenu")
        span 
        | Dashboard

    li(v-if="!userIsCompany", :class="{'active': menu === 'registration'}",  style="cursor: pointer", @click.prevent="menu = 'registration'")
        span 
        | Perfil Profissional
        ul.sub-item(v-if="menu === 'registration'")
          router-link(:to="{name: 'professional.record.registration.me'}", tag="li", active-class="sub-active", @click.native="hiddenMenu")
            span 
            a(href="#") Cadastro
          router-link(:to="{name: 'professional.record.specialities.index'}", tag="li", active-class="sub-active", @click.native="hiddenMenu")
            span 
            a(href="#") Especialidade

    li(:class="{'active': menu === 'company-me' || activeCompanyMe }", style="cursor: pointer", @click.prevent="menu = 'company-me'")
      span 
      | Dados Cadastrais
      ul.sub-item(v-if="menu === 'company-me'")

        router-link(
          :to="{name: 'professional.company.companies.edit'}",
          tag="li",
          active-class="sub-active",
          v-if="userIsCompany",
          @click.native="hiddenMenu")
         span 
         a(href="#")
           | Estabelecimento

        router-link(
          :to="{name: 'professional.company.addresses.index'}",
          tag="li",
          active-class="sub-active",
          @click.native="hiddenMenu")
         span 
         a(href="#") Local de Atendimento

        router-link(
          :to="{name: 'professional.company.covenants.index'}",
          tag="li",
          active-class="sub-active",
          @click.native="hiddenMenu")
         span 
         a(href="#") Convênios


        router-link(
          v-if="userIsCompany",
          :to="{name: 'professional.company.staffs.index'}",
          tag="li",
          active-class="sub-active",
          @click.native="hiddenMenu")

         span 
         a(href="#") Corpo Clínico


        router-link(
          :to="{name: 'professional.company.prices.index'}",
          tag="li",
          active-class="sub-active",
          @click.native="hiddenMenu")
         span 
         a(href="#") Honorários

        router-link(
          :to="{name: 'professional.company.employees.index'}",
           tag="li",
           active-class="sub-active",
           @click.native="hiddenMenu")
          span 
          a(href="#") Funcionários

    li(:class="{'active': menu === 'agenda'}", style="cursor: pointer", @click.prevent="menu = 'agenda'")
      span 
      | Agenda Profissional
      ul.sub-item(v-if="menu === 'agenda'")
        router-link(
          :to="{name: 'professional.agenda.agendas.index'}",
           tag="li",
           active-class="sub-active",
           @click.native="hiddenMenu")
          span 
          a(href="#") Cadastro

        router-link(
          :to="{name: 'professional.agenda.rules.index'}",
           tag="li",
           active-class="sub-active",
           @click.native="hiddenMenu")
          span 
          a(href="#") Regras

        router-link(
          :to="{name: 'professional.agenda.locks.index'}",
          tag="li",
          active-class="sub-active",
          @click.native="hiddenMenu")
          span 
          a(href="#") Bloqueios

    li(:class="{'active': menu === 'schedulings'}", @click.prevent="menu = 'schedulings'")
      router-link(
        :to="{ name: 'professional.schedulings.index'}",
        @click.native="hiddenMenu")
        span 
        | Agendamentos

    //-li
      span 
      | Relatórios
    li(:class="{'active': menu === 'curriculum'}", v-if="!userIsCompany", style="cursor: pointer", @click.prevent="menu = 'curriculum'")
      span 
      | Curriculum
      ul.sub-item(v-if="menu === 'curriculum'")
        router-link(
          :to="{name: 'professional.curriculum.graduations.index'}",
          tag="li",
          active-class="sub-active",
          @click.native="hiddenMenu")
          span 
          a(href="#") Graduação

        router-link(
          :to="{name: 'professional.curriculum.specializations.index'}",
          tag="li",
          active-class="sub-active",
          @click.native="hiddenMenu")
          span 
          a(href="#") Especialização

    li(:class="{'active': menu === 'documents'}", @click.prevent="menu = 'documents'", style="cursor: pointer", v-if="userIsProfessional")
      router-link(:to="{ name: 'professional.documents.create'}", @click.native="hiddenMenu")
        span 
        | Documentos
        professional-documents-score

    li(:class="{'active': menu === 'company-documents' || activeCompanyDocumente}", @click.prevent="menu = 'company-documents'", style="cursor: pointer", v-if="userIsCompany")
      router-link(:to="{ name: 'professional.company.documents.create'}", @click.native="hiddenMenu")
        span 
        | Documentos
        professional-documents-score

</template>



// WEBPACK FOOTER //
// src/layout/professional/sidebar.vue